<form class="form-horizontal" #form="ngForm" (ngSubmit)="onSubmit()">
    <div class="mb-3 row">

      <div class="form-group col-sm-6" [class.has-error]="date.invalid  && name.touched">
        <label class="control-label">{{ 'Date' | translate }}:</label>
        <div>
          <input  type="text" name="date" class="form-control" disabled
            placeholder="{{ 'Enter date' | translate }}"  required [(ngModel)]="this.datehoy"  #date="ngModel">
        </div>
      </div>

      <div class="col-sm-6">
        <label class="control-label">{{ 'Management type' | translate }}:</label>
        <select
          class="form-control" name="status" [ngModel]="edited.type_management"
          (ngModelChange)="onSelectStatus($event)" required>
          <!-- <option [ngValue]="transactionStatus.ACTIVE">
            {{ transactionStatusText[transactionStatus.ACTIVE] | translate }}
          </option>
          <option
           
            [ngValue]="transactionStatus.DELAYED">
            {{ transactionStatusText[transactionStatus.DELAYED] | translate }}
          </option> -->
          <option [ngValue]="transactionStatus.CANCELED">
            {{ transactionStatusText[transactionStatus.CANCELED] | translate }}
          </option>

          <option [ngValue]="transactionStatus.RET">
            {{ transactionStatusText[transactionStatus.RET] | translate }}
          </option>

          <option [ngValue]="transactionStatus.SO">
            {{ transactionStatusText[transactionStatus.SO] | translate }}
          </option>

          <option [ngValue]="transactionStatus.KIT">
            {{ transactionStatusText[transactionStatus.KIT] | translate }}
          </option>

      
        </select>
      </div>
    
 
    </div>

            <!-- si es cancelacion muestro otro 3er combobox -->
      <div *ngIf="edited.type_management==3" class="mb-3 row">

      <div  class="col-sm-6">
      <label class="control-label">{{ 'Sub type management' | translate }}:</label>
      <div class="checkbox">
        <select name="country_id" class="form-control" [(ngModel)]="edited.subtype_management"
          (ngModelChange)="onSelectCancellationtype($event)" required>
          <option *ngFor="let element of subtypologies" [ngValue]="element.id">{{ element.description }}</option>
        </select>
      </div>
      </div>


      <div class="col-sm-6">
      <label class="control-label">{{ 'Cancellation detail' | translate }}:</label>
      <div class="checkbox">
        <select name="subtype2_management" class="form-control" [(ngModel)]="edited.subtype2_management"
          (ngModelChange)="onSelectCancellationsubtype($event)" required>
          <option *ngFor="let element of subtypologiescancellation" [ngValue]="element.id">{{ element.description }}</option>
        </select>
      </div>
      </div>

      </div>


               <!-- si es DIFERENTE DE CANCELACION Y ENVIO DE KIT -->
               <div *ngIf="edited.type_management!=3 && edited.type_management!=6" class="mb-3 row">

                <div  class="col-sm-12">
                <label class="control-label">{{ 'Sub type management' | translate }}:</label>
                <div class="checkbox">
                  <select name="country_id" class="form-control" [(ngModel)]="edited.subtype_management"
                    (ngModelChange)="onSelectsubtypology($event)" required>
                    <option *ngFor="let element of subtypologies" [ngValue]="element.id">{{ element.description }}</option>
                  </select>
                </div>
                </div>
          
          
        
          
                </div>




    <div class="mb-3 row">

      <div class="form-group col-sm-6" [class.has-error]="customer_id.invalid && customer_id.touched">
        <label class="control-label">{{ 'Customer identification' | translate }}:</label>
        <div>
          <input  type="text" name="customer_id" class="form-control" pattern=".{1,50}"
            [(ngModel)]="edited.customer_id" required #customer_id="ngModel">
        </div>
      </div>

   
     
      <div class="form-group col-sm-6" [class.has-error]="name.invalid && name.touched">
        <label class="control-label">{{ 'Customer name' | translate }}:</label>
        <div>
          <input  type="text" name="name" class="form-control" 
           [(ngModel)]="edited.customer_name" required #name="ngModel">
        </div>
      </div>


    </div>


    <div class="mb-3 row">

      

      <div class="form-group col-sm-6" [class.has-error]="customer_phone.invalid && customer_phone.touched">
        <label class="control-label">{{ 'Customer phone' | translate }}:</label>
        <div>
          <input  type="text" name="name" class="form-control" pattern=".{1,50}"
             [(ngModel)]="edited.customer_phone" required #customer_phone="ngModel">
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label class="control-label">{{ 'Country' | translate }}:</label>
        <div class="checkbox">
          <select name="country_id" class="form-control" [(ngModel)]="cadenacountry"
            (ngModelChange)="onSelectCountry($event)" required>
            <option *ngFor="let country of countries | async" [ngValue]="country.id+'_'+country.name">{{ country.name }}</option>
          </select>
        </div>
      </div>

   
      
    </div>
 


    <div class="mb-3 row">
      <div class="form-group col-sm-6">
        <label class="control-label">{{ 'Sponsor' | translate }}:</label>
        <div class="checkbox">
          <select name="sponsor_id" class="form-control" [(ngModel)]="cadenasponsor"  (ngModelChange)="onSelectSponsor($event)" required>
            <option *ngFor="let sponsor of sponsors" [ngValue]="sponsor['id']+'_'+sponsor['name']">{{ sponsor['name'] }}</option>
          </select>
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label class="control-label">{{ 'Product' | translate }}:</label>
        <div class="checkbox">
          <select name="product_id" class="form-control" [(ngModel)]="cadenaproduct" (ngModelChange)="onSelectProductponsor($event)" required>
            <option *ngFor="let assistance of assistances" [ngValue]="assistance['id']+'_'+assistance['name']">{{ assistance['name'] }}</option>
          </select>
        </div>
      </div>



  
    </div>


    <div class="mb-3 row">
      
      <div class="form-group col-sm-6" [class.has-error]="assistance_code.invalid && assistance_code.touched">
        <label class="control-label">{{ 'Attendance Code' | translate }}:</label>
        <div>
          <input  type="text" name="assistance_code" class="form-control" 
             [(ngModel)]="edited.assistance_code" required #assistance_code="ngModel">
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label class="control-label">{{ 'Sales Channel' | translate }}:</label>
        <div class="checkbox">
          <select name="sales_chanel_id" class="form-control" [(ngModel)]="cadenachannel" (ngModelChange)="onSelectChannel($event)" required>
            <option [ngValue]="'1'+'_'+'Telemercado'">Telemercado</option>
            <option [ngValue]="'2'+'_'+'Surcursales'">Surcursales</option>
            <option [ngValue]="'3'+'_'+'Digital'">Digital</option>
            <option [ngValue]="'4'+'_'+'Otro'">Otro</option>
          </select>
        </div>
      </div>

   
    </div>

    <div class="mb-3 row"> 
      <div class="col-md-6 ml-auto">
        <label class="control-label">{{ 'Severity' | translate }}:</label>
        <div class="col-sm-3" style="display: flex; align-items: center;justify-content: center; width: 25%;margin-left: 90px;">
          <div id="traffic-light" >
            <button type="button" class="{{getclass1(30)}}" (click)="setRed()">Urgente</button>
            <button type="button" class="{{getclass2(20)}}" (click)="setYellow()">Intermedio</button>
            <button type="button" class="{{getclass3(10)}}" (click)="setGreen()">Normal</button>
          </div> 
        </div>
      </div>



      <div class="form-group col-sm-6" [class.has-error]="comment.invalid && comment.touched">
        <label class="control-label">{{ 'Comment' | translate }}:</label>
        <div>
          <textarea  type="text" name="comment" class="form-control"
           [(ngModel)]="edited.comment" required #comment="ngModel"> </textarea>
        </div>
      </div>
    </div>
 
  
    <div class="mb-3 row">
      <div class="col-md-12 text-end mt-2">
        <button type="button" class="btn secundary-btn secundary-btn-fw" (click)="onCancel()">
          <span >
            {{ 'Cancel' | translate }}
          </span>
          <!-- <span >
            {{ 'Close' | translate }}
          </span> -->
        </button>
        <button type="submit" class="btn primary-btn primary-btn-fw"
          [disabled]="form.form.invalid || form.form.pending || isDisabled">
          <span *ngIf="edited.id">
            {{ 'Save' | translate }}
          </span>
          <span *ngIf="!edited.id">
            {{ 'Create' | translate }}
          </span>
        </button>
      </div>
    </div>
  </form>